export enum RoundTypeEnum {
  UP = 'UP',
  DOWN = 'DOWN',
  ALGEBRAIC = 'ALGEBRAIC',
}
